import { AT_TYPES } from "./entity.js";

export const IMAGE_VENDORS = {
  CORE: "core",
  GOLDEN: "golden",
  PIXIT: "pixit",
  WEKA: "weka"
};

export const GOLDEN_IMAGE_TYPES = [
  AT_TYPES.NODE_GOLDEN_IMAGE,
  AT_TYPES.SNOWFLAKE_GOLDEN_IMAGE,
  AT_TYPES.WORKSTATION_GOLDEN_IMAGE
];

export const ALL_IMAGE_TYPES = [
  AT_TYPES.IMAGE,
  AT_TYPES.CONTAINER_IMAGE,
  AT_TYPES.DATABASE_IMAGE,
  AT_TYPES.DISPLAY_GATEWAY_IMAGE,
  AT_TYPES.NODE_IMAGE,
  AT_TYPES.NODE_GOLDEN_IMAGE,
  AT_TYPES.SNOWFLAKE_IMAGE,
  AT_TYPES.SNOWFLAKE_GOLDEN_IMAGE,
  AT_TYPES.WORKSTATION_IMAGE,
  AT_TYPES.WORKSTATION_GOLDEN_IMAGE,
  AT_TYPES.VPN_GATEWAY_IMAGE
];

export const IMAGE_VENDOR_COPY_KEYS = {
  [IMAGE_VENDORS.CORE]: "core",
  [IMAGE_VENDORS.GOLDEN]: "golden",
  [IMAGE_VENDORS.PIXIT]: "pixit",
  [IMAGE_VENDORS.WEKA]: "weka",
  [AT_TYPES.NODE_GOLDEN_IMAGE]: "golden_node",
  [AT_TYPES.SNOWFLAKE_GOLDEN_IMAGE]: "golden_snowflake",
  [AT_TYPES.WORKSTATION_GOLDEN_IMAGE]: "golden_workstation"
};
